// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2KEHp","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__3MQ7p"};